
import { defineComponent, Ref, ref, onMounted, computed } from "vue";
import useAlert from "@/composables/Alert";
import useEmitter from "@/composables/Emmiter";
import Button from "@/components/Button.vue";
import axios from "axios";
import { useVehicleClipboard } from '@/composables/useVehicleClipboard'


export default defineComponent({
  name: "AdicionaVeiculo",

  components: {
    Button
   },
  props: {
    fechaModal: Function,
    veiculos: Array,
  },

  setup(props) {

    const { showTimeAlert } = useAlert();
    const emitter = useEmitter();

    const loadingSalva: Ref<boolean> = ref(false);
    const veiculo: Ref<any> = ref({ tipo_veiculo: 'leve' });
    //const copiado: Ref<boolean> = ref(false);
    const tipoSelecionado: Ref<string> = ref('filtroOleo');
    const marcasDeVeiculos: Ref<any> = ref([]);
    const loadSalvar: Ref<boolean> = ref(false);
    const spanWarning: Ref<boolean> = ref(false);
    const dadosColados = ref<any>(null);
    const { colarDadosTecnicos, copiado } = useVehicleClipboard()
    
    //FUNCAO PARA PEGAR O TOKEN
    const getToken = async () => {
      return localStorage.getItem("token_usuario");
    };
    getToken();

    //FUNCAO QUE BUSCA AS MARCAS DOS CARROS EM NOSSA BASE
    async function getMarcas() {
      try {
        const res = await axios.get("marcas", {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        marcasDeVeiculos.value = res.data;
      } catch (err) {
        console.log(err);
      }
    }

    // Validação Ano Combustível (2025 Gasolina)
    const isAnoCombustivelValid = computed(() => {
      if (!veiculo.value.ano) return false;
      const regex = /^\d{4}\s+(Gasolina|Alcool|Álcool|Diesel|Flex|Híbrido|Elétrico)$/i;
      return regex.test(veiculo.value.ano);
    });

    // Validação FIPE (000000-0)
    const isFipeValid = computed(() => {
      if (!veiculo.value.fipe) return false;
      return /^\d{6}-\d{1}$/.test(veiculo.value.fipe);
    });

    // Funções de manipulação
    const validateOnlyNumbers = (val: string, field: string) => {
      veiculo.value[field] = val.replace(/\D/g, '');
    };

    const handleFipeInput = (val: string) => {
      let cleaned = val.replace(/\D/g, ""); 
      if (cleaned.length > 6) {
        cleaned = `${cleaned.slice(0, 6)}-${cleaned.slice(6, 7)}`;
      }
      veiculo.value.fipe = cleaned;
    };

    function verifySelectValues(e) {
      e.preventDefault();

      // 1. Verificação básica de campos vazios (o que você já tinha)
      const camposVazios = !veiculo.value.codModelo || 
                          !veiculo.value.fipe || 
                          !veiculo.value.marca || 
                          !veiculo.value.modelo || 
                          !veiculo.value.combustivel || 
                          !veiculo.value.array_combustivel || 
                          !veiculo.value.ano || 
                          !veiculo.value.ano2;

      // Reutilizamos as computed properties que criamos (isFipeValid e isAnoCombustivelValid)
      
      // 2. Lógica de Bloqueio com verificações
      if (camposVazios) {
        showTimeAlert("Preencha todos os campos obrigatórios", 'error');
        return true
      } else if (!isFipeValid.value) {
          showTimeAlert("O Código FIPE digitado é inválido (use o padrão 000000-0)", 'error');
          return true
      } else if (!isAnoCombustivelValid.value) {
          showTimeAlert("O formato de Ano e Combustível está incorreto", 'error');
          return true
      } else if (veiculo.value.ano2.length < 4) {
          showTimeAlert("O formato do Ano está incorreto", 'error');
          return true
      }

      // Se passou em tudo
      spanWarning.value = false;
      adicionarVeiculo();
    }

    async function adicionarVeiculo () {
      try {
        loadSalvar.value = true;
        emitter.emit && emitter.emit("adicionar-veiculo:start");
        const res = await axios.post(
          "atualizaDadosVeiculo",
          { ...veiculo.value },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        );
        // notifica o listener (parent) sobre o sucesso
        emitter.emit && emitter.emit("adicionar-veiculo:finish", { success: true, veiculo: res.data });
        showTimeAlert("Veículo adicionado com sucesso!");
        // limpa o formulário local
        veiculo.value = {};
      } catch (err) {
        emitter.emit && emitter.emit("adicionar-veiculo:finish", { success: false, error: err });
        showTimeAlert("Não foi possivel adicionar o veículo.", "error");
      } finally {
        loadSalvar.value = false;
      }
    };


    // Função para colar produtos diretamente no veiculo
    function colarDadosTecnicosNoVeiculo() {
      const dadosColados = colarDadosTecnicos()
      console.log(dadosColados);
      
      if (dadosColados) {
        // Atribui a cada ref individual
        veiculo.value.lubrificante_sae = dadosColados.lubrificante_sae || ''
        veiculo.value.lubrificante_acea = dadosColados.lubrificante_acea || ''
        veiculo.value.lubrificante_api = dadosColados.lubrificante_api || ''
        veiculo.value.lubrificante_base = dadosColados.lubrificante_base || ''
        veiculo.value.lubrificante_ilsac = dadosColados.lubrificante_ilsac || ''
        veiculo.value.lubrificante_oem = dadosColados.lubrificante_oem || ''
        veiculo.value.carter_com_filtro = dadosColados.carter_com_filtro || ''
        veiculo.value.pneu_dianteiro_1 = dadosColados.pneu_dianteiro_1 || ''
        veiculo.value.pneu_dianteiro_2 = dadosColados.pneu_dianteiro_2 || ''
        veiculo.value.pneu_traseiro_1 = dadosColados.pneu_traseiro_1 || ''
        veiculo.value.pneu_traseiro_2 = dadosColados.pneu_traseiro_2 || ''
        veiculo.value.modelo_palheta = dadosColados.modelo_palheta || ''
        veiculo.value.motorista_palheta = dadosColados.motorista_palheta || ''
        veiculo.value.passageiro_palheta = dadosColados.passageiro_palheta || ''
        veiculo.value.traseiro_palheta = dadosColados.traseiro_palheta || ''
        veiculo.value.adaptador_palheta = dadosColados.adaptador_palheta || ''
        // ... atribua os demais campos
      }
    }

    // Opcional: botão para limpar clipboard
    function limparClipboard() {
      const { limparClipboard } = useVehicleClipboard()
      limparClipboard()
    }

    onMounted(async() => {
      getMarcas()
    })

    const dismiss = () => {
      props.fechaModal && props.fechaModal();
    }

    return { spanWarning, dismiss, adicionarVeiculo, verifySelectValues, veiculo, tipoSelecionado, copiado, loadingSalva, marcasDeVeiculos, loadSalvar, handleFipeInput, isAnoCombustivelValid, isFipeValid, validateOnlyNumbers, colarDadosTecnicosNoVeiculo, limparClipboard, dadosColados}
  }

})

